import { Next, select, sleep, takeLeading } from "starfx";

import { dateToSqlDate, ensureArray } from "@app/service/helpers";
import { isErr, isOk, safeLast } from "@app/statefx/helpers";
import { schema } from "@app/statefx/schema";
import { xApi, xWorker } from "@app/statefx/xapis";

import type { ApiCtx } from "starfx";
function* parseableCtx(ctx: ApiCtx) {
  yield* sleep(1);
  return ctx.json;
}
export const sfxFetchMonede = xWorker.get(
  "/get-wait/assets/monede",
  { supervisor: takeLeading },
  function* (ctx, next) {
    ctx.request = ctx.req({
      url: "/assets/monede",
      method: "GET",
    });
    yield* next();
    const data = yield* safeLast(parseableCtx(ctx));
    if (isErr(data)) {
      console.log("error in data", data);
      return;
    }
    const dt = ensureArray(data.value).filter(
      (x: any) => !["ROL", "MDL"].includes(x)
    );
    const _crtCurrency = yield* select(schema.uiInvoiceOverall.select);
    const crtCurrency = _crtCurrency.currentCurrency;

    yield* schema.update([
      schema.currencies.set(dt),
      schema.uiInvoiceOverall.update({
        key: "currentCurrency",
        value: crtCurrency || "RON",
      }),
    ]);
  }
);

// export const getExchangeRates = xApi.get<{ startdate: string }>(
//   '/xapi/getExchangeRates',
//   { supervisor: takeLeading },
//   function* (ctx: ApiCtx, next: Next) {
//     const { startdate } = ctx.payload;
//     ctx.request = ctx.req({
//       method: 'GET',
//       url: `/assets/exrate?starting=${startdate}`,
//     });
//     yield* next();
//     if (isErr(ctx.json)) {
//       console.error('Error fetching exchange rates', ctx.json.error);
//       return;
//     }
//     if (isOk(ctx.json)) {
//       const data = ctx.json.value;
//       const indexedData = data.reduce(
//         (acc: Record<string, IExchangeRate>, jsonString: string) => {
//           try {
//             const record: IExchangeRate = JSON.parse(jsonString);
//             if (record.XRDATESTRING) {
//               acc[record.XRDATESTRING] = record;
//             }
//           } catch (error) {
//             console.error(`Error parsing JSON string: ${jsonString}`, error);
//             //continue
//           }
//           return acc;
//         },
//         {},
//       );
//       yield* schema.update(schema.currencyRates.set(indexedData));
//     }
//   },
// );

// last 60 days
//  const immediate =  sub(new Date(), { days: 60 });
//  const immediateStart = dateToSqlDate(immediate);

export const wgetExchangeRates = xWorker.get(
  "WGET/select/loadexrate",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    const appstate = yield* select(schema.app.select);
    const start = dateToSqlDate(new Date(appstate.absolutestart));
    ctx.request = ctx.req({
      url: `/select/loadexrate?start=${start}&env=${process.env.REACT_APP_MODE}`,
    });
    yield* next();
  }
);

export const wsyncExrates = xWorker.get(
  "WSYNC/select/loadexrate",
  { supervisor: takeLeading },
  function* (ctx: ApiCtx, next: Next) {
    const appstate = yield* select(schema.app.select);
    const start = dateToSqlDate(new Date(appstate.absolutestart));
    const syncCode = "SET/select/currencyrate";
    ctx.request = ctx.req({
      url: `/sync:get/select/loadexrate?start=${start}&env=${process.env.REACT_APP_MODE}&syncCode=${syncCode}`,
    });
    yield* next();
  }
);
